console.log('Made by Shin Agency')

jQuery( document ).ready(function() {

    $(window).bind('scroll', function(){
      if($(this).scrollTop() > 200) { 
        $("#scroll_to_top_button").addClass("visible");
      } else if($(this).scrollTop() == 0){
        $("#scroll_to_top_button").removeClass("visible");
      }
    });

    $("#scroll_to_top_button").click(function () {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
      $(this).removeClass("visible"); 
      return false;
    });
    
    if ( $('.acc-current-menu-parent').length ) {
      $('.acc-current-menu-parent').attr('open', true);
    }
    
    if ( $('.fondations_listprix').length ) {

        var selected = $('#fondationByDate option:not(.hidden)').val();
        $('#fondationByDate').val(selected);

        $(".prix_"+selected).removeClass('hidden');

        $('#fondationByDate').change(function(e){
            e.preventDefault();
            $('.fondation_prix').addClass('hidden');
            var select = $(this).val();
            $(".prix_"+select).removeClass('hidden');
        });

        $('.fondations_listprix_title').on('click', function (e) {
            e.preventDefault();
            $(".fondations_detail_article_articleZone_data").html("");
            $('.fondations_detail_article_articleZone_data').append( "<div class='loader'></div>" );
            $('.fondations_detail').addClass("visible");
            $('.div_modal_light').addClass("visible");
            $('html').addClass("modal_visible");
            setTimeout(function () {
              $('.fondations_detail_close').filter(':visible').focus();
            }, 500);

            var id_taxanomy = $(this).data("id");

            console.log(id_taxanomy);
            $.ajax({
                type: 'POST',
                url: ajax_auth_object.ajaxurl,
                data: {
                  action: "fetch_prix_detail",
                  id_taxanomy:id_taxanomy, // Pass the data
                },
                success: function(data) {
                    $(".fondations_detail_article_articleZone_data").append(data);
                    $('.loader').remove();
                }
              });
        });
        $('.fondations_listprix_link').on('click', function (e) {
            e.preventDefault();
            $(".fondations_detail_article_articleZone_data").html("");
            $('.fondations_detail_article_articleZone_data').append( "<div class='loader'></div>" );
            $('.fondations_detail').addClass("visible");
            $('.div_modal_light').addClass("visible");
            $('html').addClass("modal_visible");
            setTimeout(function () {
              $('.fondations_detail_close').filter(':visible').focus();
            }, 500);

            var id_taxanomy = $(this).data("id");

            $.ajax({
                type: 'POST',
                url: ajax_auth_object.ajaxurl,
                data: {
                  action: "fetch_prix_detail",
                  id_taxanomy:id_taxanomy, // Pass the data
                },
                success: function(data) {
                    $(".fondations_detail_article_articleZone_data").append(data);
                    $('.loader').remove();
                }
              });
        });

        $('.fondations_detail_close').on('click', function (e) {
            e.preventDefault();
            $('.fondations_detail').removeClass("visible");
            $('.div_modal_light').removeClass("visible");
            $('.fondations_listprix_title').focus();
            $('html').removeClass("modal_visible");
        });
    }

    if ( $('.fondations_works_detail').length ) {

      $('.fondations_works_detail_description').each(function(){
        if ($(".fondations_works_detail_description_text").html().length > 250) { 
            $(this).find(".fondations_works_detail_description_text .content").addClass("fixed");
        }
      });

      $('.readmore').on('click', function (e) {
          e.preventDefault();
          $(this).parent(".fondations_works_detail_description_text").find("div.fixed").removeClass("fixed");
          $(this).parent(".fondations_works_detail_description_text").find(".lessmore").addClass("show");
          $(this).addClass("hide");
          $(this).parent(".fondations_works_detail_description_text").find(".lessmore").focus();
      });
      $('.readmore').keypress(function(event){
        if(event.keyCode == 13){
          $(this).click();
        }
      });
      $('.lessmore').on('click', function (e) {
        e.preventDefault();
        $(this).parent(".fondations_works_detail_description_text").find("div.content").addClass("fixed");
        $(this).parent(".fondations_works_detail_description_text").find(".readmore").removeClass("hide");
        $(this).removeClass("show");
        $(this).parent(".fondations_works_detail_description_text").find(".readmore").focus();
      });
      $('.lessmore').keypress(function(event){
        if(event.keyCode == 13){
          $(this).click();
        }
      });
    }

    var owl = $(".slider_aibl");
    owl.owlCarousel({
      responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1.2,
              margin: 15,
              stagePadding: 30 
          },
          // breakpoint from 480 up
          768 : {
              items: 2.5,
              margin: 30,
          },
          // breakpoint from 425 up
          991 : {
              margin: 30,
              items: 3.5
          }
      },
        dots: false,
        navContainer: '.slider_aibl_customNav',
        nav : true, 
        loop : true, 
        addClassActive : true,
        onInitialized: function (event) {
            $('.slider_aibl').find('.owl-item').attr('aria-selected','false');
            $('.slider_aibl').find('.owl-item.active').attr('aria-selected','true'); // let screen readers know an item is active

            $('.slider_aibl').find('.owl-prev').attr('role','button').attr('title','Previous');
            $('.slider_aibl').find('.owl-next').attr('role','button').attr('title','Next');
            $('.owl-prev, .owl-next').attr('tabindex','0');

            
            $(document).on('keydown', function(e){

                var $focusedElement = $(document.activeElement),
                    singleOwl = $(".slider_aibl"),
                    type = e.which == 39? 'next': null,
                    type = e.which == 37? 'prev': type,
                    type = e.which == 13? 'enter':type;

                // if the carousel is focused, use left and right arrow keys to navigate
                if($focusedElement.hasClass('class') === 'slider_aibl'){

                    if (type == 'next') {
                        singleOwl.next();
                    } else if (type == 'prev') {
                        singleOwl.prev();
                    }

                    // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                } else if (type == 'enter') {
                    if ($focusedElement.hasClass('owl-next')) {
                        singleOwl.next();
                    } else if ($focusedElement.hasClass('owl-prev')) {
                        singleOwl.prev();
                    }
                }
            });
        },
        // let screen readers know which slide is active after navigation or reinit
        onChange : function() {
            $('.slider_aibl').find('.owl-item').attr('aria-selected','false');
            $('.slider_aibl').find('.owl-item.active').attr('aria-selected','true');
        }
    });
  
    if ($('.academicien_videos').length > 0 ) {
      $(".academicien_videos_card").slice(0, 8).show();

      $(".academicien_videos_loadMore").on('click', function(e) {
        e.preventDefault();

        $(".academicien_videos_card:hidden").slice(0, 8).slideDown();
        if ($(".academicien_videos_card:hidden").length == 0) {
          $(".academicien_videos_loadMore").fadeOut('slow');
        }
      });
    }


    $('.select-year-category').change(function(e){
        e.preventDefault();
        var select = $(this).val();
        if (select == 'all') {
          $('.listcategorycollections_showmore').hide();
          $('.listcategorycollections_card').removeClass('hidden');
          $('.listcategorycollections_card').addClass('show');
        } else {
          $('.listcategorycollections_showmore').hide();
          $('.listcategorycollections_card').addClass('hidden');
          $('.listcategorycollections_card').removeClass('show');
          $(".listcategorycollections_card.item_"+select).removeClass('hidden');
          $(".listcategorycollections_card.item_"+select).addClass('show');
        }
    });

    $('.select-year-seance').change(function(e){
        e.preventDefault();
        var select = $(this).val();
        if (select == 'all') {
          $('.membre_prix').removeClass('hidden');
        } else {
          $('.membre_prix').addClass('hidden');
          $(".membre_prix.prix_"+select).removeClass('hidden');
        }
    });

    $('.select-year-lettre').change(function(e){
        e.preventDefault();
        var select = $(this).val();
        if (select == 'all') {
          $('.listlettresinformations_card').removeClass('hidden');
        } else {
          $('.listlettresinformations_card').addClass('hidden');
          $(".listlettresinformations_card.item_"+select).removeClass('hidden');
        }
    });
});
